"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIALOG_COMPONENT_ID = exports.CaptchaApiSymbol = void 0;
exports.CaptchaApiSymbol = Symbol('CaptchaApi');
exports.DIALOG_COMPONENT_ID = 'CAPTCHA_DIALOG_ROOT_COMP';
//# sourceMappingURL=captcha.js.map